import MinerBlocks from './MinerBlocks';

export default MinerBlocks;
